const TH = {
  Refreshing: "กำลังโหลด",
  Refresh: "รีเฟรช",
  Thai: "ไทย",
  English: "อังกฤษ",
  Euro: "ยูโร",
  Hongkong: "ฮ่องกง",
  Malay: "มาเลย์",
  "Sign Out": "ออกจากระบบ",
  Change: "เปลี่ยน",
  to: "จาก",
  "Account Info": "ข้อมลูบัญชี",
  "Odds type": "ค่าน้ำ",
  Languages: "ภาษา",
  Results: "ผลการแข่งขัน",
  Back: "ย้อนกลับ",
  Draw: "เสมอ",
  Refund: "คืนเงิน",
  win: "ชนะ",
  lose: "แพ้",
  "half win": "ชนะครึ่ง",
  "half lose": "แพ้ครึ่ง",
  "half_win": "ชนะครึ่ง",
  "half_lose": "แพ้ครึ่ง",
  draw: "เสมอ",
  refund: "คืนเงิน",
  running: "รอผลการแข่ง",
  waiting: "รอดำเนินการ",
  cancelled: "ยกเลิก",
  "All Announcement": "ประกาศทั้งหมด",
  "List of Sports": "รายการกีฬา",
  Football: "ฟุตบอล",
  Basketball: "บาสเก็ตบอล",
  "Coming Soon": "เร็วๆนี้",
  Cricket: "คริกเก็ต",
  Volleyball: "วอลเลย์บอล",
  Boxing: "มวย",
  "Thai boxing": "มวยไทย",
  Cockfight: "ไก่ชน",
  Bullfight: "วัวชน",
  Combo: "คอมโบ",
  "Table Tennis": "ปิงปอง",
  Tennis: "เทนนิส",
  "All Result": "ผลการแข่งขัน",
  Rules: "กฎกติกา",
  "Rules and regulations": "กฎและกติกา",
  Statement: "รายการบัญชี",
  "Date time": "ระยะเวลา",
  Type: "ประเภท",
  "Date & Time": "วันที่ & เวลา",
  Time: "เวลา",
  Event: "การแข่งขัน",
  "Full Time": "เต็มเวลา",
  "First Half": "ครึ่งแรก",
  "Live / Today": "สด / วันนี้",
  Live: "สดตอนนี้",
  Today: "วันนี้",
  Early: "ล่วงหน้า",
  ALL: "ทั้งหมด",
  Leagues: "ลีก",
  League: "ลีก",
  Search: "ค้นหา",
  "Select / Cancel all": "เลือก / ยกเลิก ทั้งหมด",
  selected: "เลือกแล้ว",
  "League is not found": "ไม่พบลีกที่ค้นหา",
  Confirm: "ยืนยัน",
  Cancel: "ยกเลิก",
  "No market": "ยังไม่มีราคาให้เปิดเดิมพัน",
  "No competition": "ไม่มีรายการแข่งขัน",
  "No statement on this date range": "ไม่พบรายการบัญชี ตามช่วงเวลาที่เลือกไว้",
  Competition: "การแข่งขัน",
  "Half-time": "ครึ่งแรก",
  "Second Half": "ครึ่งหลัง",
  Q1: "ควอเตอร์ 1",
  Q2: "ควอเตอร์ 2",
  Q3: "ควอเตอร์ 3",
  Q4: "ควอเตอร์ 4",
  OT: "ต่อเวลา",
  "Match Result": "ผลจบการแข่งขัน",
  "Set 1": "เซต 1",
  "Set 2": "เซต 2",
  "Set 3": "เซต 3",
  "Set 4": "เซต 4",
  "Set 5": "เซต 5",
  "Total Points": "แต้มทั้งหมด",
  "Game 1": "เกม 1",
  "Game 2": "เกม 2",
  "Game 3": "เกม 3",
  "Total Games": "เกมทั้งหมด",
  "Kickoff Time": "เวลาเริ่มแข่งขัน",
  Match: "การแข่งขัน",
  Final: "ผลสุดท้าย",
  "Total Sets": "เซตทั้งหมด",
  "Full-time": "เต็มเวลา",
  Date: "วันที่",
  "No.": "ลำดับ",
  Message: "ข้อความ",
  "Bet amount": "จำนวนเงินเดิมพัน",
  "Win / Lose": "ชนะ / แพ้",
  Commission: "คอมมิชชั่น",
  Total: "รวม",
  "Place bet success": "การเดิม พันสำเร็จ",
  "Bet failed": "การเดิมพัน ไม่สำเร็จ",
  "Bet Slip": "การเดิมพัน",
  "My Bets": "บิลของคุณ",
  Parlay: "พาร์เลย์",
  Single: "เดี่ยว",
  Bet: "วางเดิมพัน",
  "Max payout": "จ่ายสูงสุด",
  Matches: "คู่",
  Max: "สูงสุด",
  Min: "ต่ำสุด",
  More: "อื่นๆ",
  VALIDATION_ERROR: "มีค่าบ้างอย่างไม่ถูกต้อง",
  RATE_LIMIT_REQUEST: "คำขอเกินกำหนด โปรดลองใหม่อีกครั้งในภายหลัง",
  CANNOT_GET_PROFILE: "ไม่สามารถดึงข้อมูลส่วนบุคคลได้",
  ODDS_CHANGED: "ราคาค่าน้ำมีการเปลี่ยนแปลง โปรดลองใหม่อีกครั้ง",
  MATCH_NOT_FOUND: "ไม่พบแข่งขัน",
  OVER_LITMIT_PER_MATCH: "จำนวนเงินต่อการแข่งขัน เกินกำหนดที่ตั้งไว้แล้ว",
  OVER_LITMIT_PER_BILL: "จำนวนเงินต่อบิล เกินกำหนดที่ตั้งไว้แล้ว",
  OVER_LITMIT_PER_DAY: "จำนวนเงินต่อวัน เกินกำหนดที่ตั้งไว้แล้ว",
  ODDS_INVALID: "ค่าน้ำผิด",
  DUPLICATE_BET: "การเดิมพันซ้ำซ้อน",
  INSUFFICIENT_BALANCE: "จำนวนเงินของคุณไม่พอ",
  LOCKED_ACCOUNT: "การใช้งานของคุณถูกล็อก",
  SUSSPENDED_ACCOUNT: "การใช้งานของคุณถูกระงับ",
  UNAVAILABLE_BET: "ไม่พบการเดิมพันที่ระบุ",
  TICKET_REJECTED: "การเดิมพันถูกยกเลิก",
  SYSTEM_ERROR: "โปรดลองใหม่อีกครั้ง ในภายหลัง",
  INVALID_CURRENCY: "ค่าเงินที่ใช้มีปัญหา",
  INVALID_AMOUNT: "จำนวนที่ระบุมามีปัญหา",
  SESSION_EXPIRED: "การเข้าระบบหมดอายุ",
  "Search Teams": "ค้นหาทีมหรือลีก...",
  Over: "สูง",
  Under: "ต่ำ",
  "share kickoff": "เตะเวลา",
  "share link": "ดูราคาได้ที่ลิงก์นี้",
  "share copied": "คัดลอกลิงก์แชร์ไปที่คลิปบอร์ดแล้ว",
  "share copy_failed": "ไม่สามารถคัดลอกลิงก์ได้",
  "Minimum parlay matches": "ต้องเล่นขั้นต่ำ {{count}} คู่",
  "Some matches unavailable": "มีบางคู่ไม่เปิดให้บริการ",
};

export default TH;
